import { FormInteractionIconId } from "@yedalabs/schema";
import { LucideIcon, Mail, Phone, User } from "lucide-react";

export const formInteractionIcons: {
    id: FormInteractionIconId;
    icon: LucideIcon;
    defaultValue: string;
    keyName: string;
}[] = [
    {
        id: "email",
        icon: Mail,
        defaultValue: "מייל",
        keyName: "video-interactions.form.field-icons.email",
    },
    {
        id: "user",
        icon: User,
        defaultValue: "שם",
        keyName: "video-interactions.form.field-icons.user",
    },
    {
        id: "phone",
        icon: Phone,
        defaultValue: "טלפון",
        keyName: "video-interactions.form.field-icons.phone",
    },
];
